import { isDev } from 'Utils/Utils';
const Configs = {
  API_URL: isDev()
    ? `http://localhost:3888/api/`
    : `https://blueguardian.cr.wb.gy/api/`,
  BASE_URL: isDev() ? `http://localhost:3889/` : `https://bg.wb.gy/`,
};
export default Configs;
